const ON_CHANGE_DEBOUNCE_TIMER = 300

/**
 * Currencies where Shopify stores prices in whole major units (no ÷100).
 * Keep in sync with `snippets/format-money.liquid` and `assets/global.js` usage.
 * @type {ReadonlyArray<string>}
 */
window.SACHEU_FORMAT_MONEY_ZERO_DECIMAL_CURRENCIES = Object.freeze([
  'BIF', 'CLP', 'DJF', 'GNF', 'ISK', 'JPY', 'KMF', 'KRW', 'MGA',
  'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF',
])

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
}
